import { createIcon } from '@chakra-ui/icons'

// using `path`
export const SelfstudyIcon = createIcon({
  displayName: 'SelfstudyIcon',
  viewBox:"0, 0, 800,800",

  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (<g transform="translate(0.000000,700.000000) scale(0.100000,-0.100000)"
  fill="#000000" stroke="none">
  <path d="M3105 6709 c-389 -41 -786 -205 -1089 -449 -512 -414 -794 -1021
  -773 -1665 21 -651 338 -1228 882 -1609 44 -31 97 -68 119 -83 54 -39 113
  -126 136 -201 19 -60 20 -94 20 -499 0 -368 2 -438 15 -463 33 -63 -24 -60
  1070 -60 714 0 1003 3 1018 11 58 30 57 16 57 487 l0 432 229 0 c200 0 237 2
  292 20 77 24 151 78 196 143 61 90 63 106 63 567 l0 415 151 115 c172 130 220
  179 249 256 25 68 27 181 4 248 -10 28 -75 130 -155 241 -75 106 -147 212
  -159 235 -12 23 -30 88 -41 144 -70 358 -187 629 -393 906 -426 572 -1160 886
  -1891 809z m445 -209 c221 -28 414 -86 615 -184 217 -107 370 -219 540 -398
  135 -141 221 -264 310 -443 86 -174 125 -287 161 -464 46 -230 61 -262 232
  -500 69 -95 131 -191 139 -212 29 -87 3 -124 -209 -286 -97 -74 -180 -143
  -185 -152 -4 -9 -10 -224 -13 -478 -5 -449 -6 -462 -26 -490 -11 -15 -36 -38
  -54 -50 -32 -23 -39 -23 -322 -23 -237 0 -294 -3 -318 -15 -62 -32 -60 -18
  -60 -492 l0 -433 -869 0 -869 0 -5 393 c-4 435 -6 451 -73 584 -48 96 -123
  177 -236 253 -259 176 -439 357 -581 582 -206 328 -298 696 -275 1101 19 347
  156 702 382 992 62 80 214 234 301 305 265 217 609 365 950 409 100 12 366 13
  465 1z"/>
  <path d="M2355 5871 c-11 -5 -29 -19 -40 -31 -19 -21 -20 -38 -23 -374 -2
  -334 -1 -353 17 -383 28 -45 68 -53 259 -53 l162 0 -2 -207 -3 -208 -183 -3
  c-202 -3 -219 -7 -243 -63 -18 -46 -2 -98 40 -126 26 -17 48 -23 92 -23 l59 0
  0 -210 0 -210 -66 0 c-62 0 -68 -2 -100 -34 -47 -47 -47 -95 0 -142 l34 -34
  884 0 885 0 44 23 c24 13 58 43 74 66 l30 43 5 246 5 247 180 2 c194 3 217 8
  241 55 22 43 17 84 -15 120 -26 30 -35 33 -100 36 l-71 4 0 214 0 214 55 0
  c61 0 108 19 125 49 19 36 12 98 -14 128 l-24 28 -189 5 -188 5 -5 247 -5 246
  -30 43 c-16 23 -48 52 -70 63 -40 21 -49 21 -920 23 -484 1 -889 -2 -900 -6z
  m1005 -411 l0 -210 -430 0 -430 0 0 210 0 210 430 0 430 0 0 -210z m310 0 l0
  -210 -50 0 -50 0 0 210 0 210 50 0 50 0 0 -210z m400 0 l0 -210 -95 0 -95 0 0
  210 0 210 95 0 95 0 0 -210z m240 -630 l0 -210 -690 0 -690 0 0 210 0 210 690
  0 690 0 0 -210z m-240 -630 l0 -210 -687 2 -688 3 -3 208 -2 207 690 0 690 0
  0 -210z"/>
  
  </g>
    
  ),
})
